/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UserMeta } from './UserMeta'
import {
  UserMetaFromJSON,
  UserMetaFromJSONTyped,
  UserMetaToJSON,
} from './UserMeta'

/**
 *
 * @export
 * @interface GetMeta200Response
 */
export interface GetMeta200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetMeta200Response
   */
  status: boolean
  /**
   *
   * @type {UserMeta}
   * @memberof GetMeta200Response
   */
  data: UserMeta
}

/**
 * Check if a given object implements the GetMeta200Response interface.
 */
export function instanceOfGetMeta200Response(
  value: object
): value is GetMeta200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetMeta200ResponseFromJSON(json: any): GetMeta200Response {
  return GetMeta200ResponseFromJSONTyped(json, false)
}

export function GetMeta200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMeta200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: UserMetaFromJSON(json['data']),
  }
}

export function GetMeta200ResponseToJSON(
  value?: GetMeta200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: UserMetaToJSON(value['data']),
  }
}
